import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import AuthForm from "../AuthForm/AuthForm";
import { MyTextField } from "../MyTextField";
import { apiAuthorization } from "../../utils/apiAuth";

export const SendOnEmailActivateLink: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const handleSubmit = async (values: { email: string }) => {
    setLoading(true);
    setError("");
    try {
      const response = await apiAuthorization().activatePasswordChange({ email: values.email.trim() });
      setMessage(response.data.message);
    } catch (e: any) {
      setError(
        e.response?.status === 429
          ? "Too many attempts. Please try again in 15 minutes."
          : "We could not confirm your request. Check your inbox before trying again."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Reset Admin Password</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="referrer" content="no-referrer" />
      </Helmet>
      <AuthForm
        titleAuthorization="Reset password"
        initialValues={{ email: "" }}
        validationSchema={Yup.object({
          email: Yup.string().trim().email("Enter a valid email.").max(254).required("Enter your admin email."),
        })}
        textButton="Send reset link"
        handleSubmit={handleSubmit}
        error={error}
        loading={loading}
        showError={Boolean(error)}
        showLinkForgotPassword={false}
        message={message}
        completed={Boolean(message)}
        textQuestion="Remember your password? "
        textAnswer="Sign in"
        pathOnAnotherAuthorization="/signin/"
      >
        <MyTextField
          nameLabel="Admin email"
          type="email"
          name="email"
          component="input"
          id="email"
          autoComplete="username"
          autoCapitalize="none"
          spellCheck={false}
        />
      </AuthForm>
    </>
  );
};
